module.exports = __webpack_public_path__ + "img/1557111211.f640ec22.jpg";